module.exports = __webpack_public_path__ + "static/media/licencia_frente.c270023e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/licencia_frente.jpg
// module id = 356
// module chunks = 0